import script from "./SecFaq.vue?vue&type=script&setup=true&lang=js"
export * from "./SecFaq.vue?vue&type=script&setup=true&lang=js"

import "./SecFaq.vue?vue&type=style&index=0&id=58dc9111&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58dc9111"]])

export default __exports__